import React from 'react';
import {
  Card,
  Typography,
  ImageWithRatio,
  LinkHandler,
} from '@/components/atoms';
import styled from 'styled-components';
import { IImageWithTextData } from '../IImageWithTextCmp';

const Container = styled.div`
  width: 100%;
  min-width: 110px;
  text-align: left;
  a {
    text-decoration: none;
  }

  &:last-child {
    margin-bottom: 0px;
  }
  line-height: 0;
`;

const CustomCard = styled(Card)`
  display: block;
`;

const InfoContainer = styled.div`
  padding: 8px 0px;
  ${props => props.theme.breakpoints.up('md')} {
    /* padding: 16px 0px; */
  }
`;

const ImageDesktop = styled.div`
  display: none;
  ${props => props.theme.breakpoints.up('md')} {
    display: block;
  }
`;
const ImageMobile = styled.div`
  display: block;
  ${props => props.theme.breakpoints.up('md')} {
    display: none;
  }
`;

const ImageWithTextCard: React.FC<IImageWithTextData> = props => {
  const { headingText, url, target, mediaMobile, media, altTag, description } =
    props;

  const content = (
    <CustomCard>
      {media &&
        media.fields &&
        media.fields.file &&
        media.fields.file.details &&
        media.fields.file.details.image && (
          <ImageDesktop>
            <ImageWithRatio
              ratio={{
                width: media?.fields?.file?.details?.image?.width,
                height: media?.fields?.file?.details?.image?.height,
              }}
              media={media}
              alt={altTag}
            />
          </ImageDesktop>
        )}

      {mediaMobile &&
        mediaMobile.fields &&
        mediaMobile.fields.file &&
        mediaMobile.fields.file.details &&
        mediaMobile.fields.file.details.image && (
          <ImageMobile>
            <ImageWithRatio
              ratio={{
                width: mediaMobile?.fields?.file?.details.image.width,
                height: mediaMobile?.fields?.file?.details.image.height,
              }}
              media={mediaMobile}
              alt={altTag}
            />
          </ImageMobile>
        )}
      {headingText || description ? (
        <InfoContainer>
          {headingText && (
            <Typography
              dangerouslySetInnerHTML={{
                __html: headingText,
              }}
              datatype="subtitle_1"
            />
          )}
          {description && (
            <Typography datatype="body_1">{description}</Typography>
          )}
        </InfoContainer>
      ) : null}
    </CustomCard>
  );

  return (
    <Container>
      {url ? (
        <LinkHandler href={url}>
          <a target={target}>{content}</a>
        </LinkHandler>
      ) : (
        content
      )}
    </Container>
  );
};

export default ImageWithTextCard;
